function setupToolTip(buttonClass, toolTipClass, isOpen = true) {
  // Select elements
  const button = document.querySelector(buttonClass);
  const toolTip = document.querySelector(toolTipClass);

  if (!button || !toolTip) {
    console.error(`Elements not found for button: ${buttonClass}, tooltip: ${toolTipClass}`);
    return;
  }

  // Initialize the state based on isOpen
  if (isOpen) {
    button.classList.add("tool-tip-open");
    toolTip.classList.remove("hidden");
    button.innerText = "-";
  } else {
    button.classList.remove("tool-tip-open");
    toolTip.classList.add("hidden");
    button.innerText = "+";
  }

  // Toggle logic on button click
  button.addEventListener("click", () => {
    // Toggle class "tool-tip-open" on button
    button.classList.toggle("tool-tip-open");

    // Toggle class "hidden" on tooltip div
    toolTip.classList.toggle("hidden");

    // Toggle button text between "-" and "+"
    button.innerText = button.classList.contains("tool-tip-open") ? "-" : "+";
  });
}
